module.exports = __webpack_public_path__ + "img/choose-preset.41d082a7.png";